const DISH_IGNORED_FILTER = {
  IGNORED: {
    label: 'Ignored',
    value: 'IGNORED',
  },
  NOT_IGNORED: {
    label: 'Not ignored',
    value: 'NOT_IGNORED',
  },
}

export default DISH_IGNORED_FILTER
